export const scrollTop = function () {
  const bodys = document.getElementsByClassName('scroll')[0];
  if (bodys) {
    bodys.scroll(0, 0);
  }
};
